module.exports = __webpack_public_path__ + "img/tl.d8a006ba.jpg";